import {defineStore} from 'pinia';
import { AxiosRequestConfig } from "axios";
import { SUBJECT_ID_MAP } from "@/consts/subject";
import apiRequest from '@/util/api-request';


interface Student{
   value:number;
   name: string;
   number: string;
}

interface LearningStatusStudent {
  student_list: Student[];
}

const useLearningStatusStudentStore = defineStore('learningStatusStudentStore', {
  // state
  state: (): LearningStatusStudent => {
    return {
      student_list: null
    }
  },
  // getters
  getters: {
    students: (state) => {
      return state.student_list
    }
  },
  // actions
  actions: {
    async fetchLearningStatusStudentListStudents({classroom_uuid}) {
      const config: AxiosRequestConfig = {
        method: "get",
        url: "/teacher/api/learning_status/student/list/",
        headers: {
          "Content-Type": "application/json",
        },
        params: {
          classroom_uuid: classroom_uuid,
        },
      };
      const students = await apiRequest(config);
       this.student_list = students.data.students
    },
    async fetchLearningStatusStudentCorrectAnswerRate({student_id, subject, work}) {
      const config: AxiosRequestConfig = {
        method: "get",
        url: "/teacher/api/learning_status/student/correct_answer_rate/",
        headers: {
          "Content-Type": "application/json",
        },
        params: {
          student_id: student_id,
          // FIXME: 引き当ては呼び出し元 component のほうでやる
          subject_id: SUBJECT_ID_MAP[subject],
          ...(work && { work_id: work }),
        },
      };
      const correctAnswerRate = await apiRequest(config);
      return correctAnswerRate.data.correct_answer_rate
    },
    async fetchLearningStatusStudentFetchDetailByYear({student_id, subject, year, work}) {
      const config: AxiosRequestConfig = {
        method: 'get',
        url: '/teacher/api/learning_status/student/detail_by_year/',
        headers: {
            'Content-Type': 'application/json',
        },
        params: {
          student_id: student_id,
          subject_id: SUBJECT_ID_MAP[subject],
          year: year,
          ...(work && { work_id: work }),
        },
      };
      const detailByYear = await apiRequest(config);
      return detailByYear.data.detail_by_year
    },
    async fetchLearningStatusStudentFetchAvgByYear({student_id, subject, year, work}) {
      const config: AxiosRequestConfig = {
        method: 'get',
        url: '/teacher/api/learning_status/student/classroom_average_by_year/',
        headers: {
            'Content-Type': 'application/json',
        },
        params: {
          student_id: student_id,
          subject_id: SUBJECT_ID_MAP[subject],
          year: year,
          ...(work && { work_id: work }),
        },
      };
      const avgByYear = await apiRequest(config);
      return avgByYear.data.classroom_average_by_year
    },
    async fetchLearningStatusStudentFetchDetailByMonth({student_id, subject, year, month, work}) {
      const config: AxiosRequestConfig = {
        method: 'get',
        url: '/teacher/api/learning_status/student/detail_by_month/',
        headers: {
            'Content-Type': 'application/json',
        },
        params: {
          student_id: student_id,
          subject_id: SUBJECT_ID_MAP[subject],
          year: year,
          month: month,
          ...(work && { work_id: work }),
        },
      };
      const detailByMonth = await apiRequest(config);
      return detailByMonth.data.detail_by_month
    },
    async fetchLearningStatusStudentFetchAvgByMonth({student_id, subject, year, month, work}) {
      const config: AxiosRequestConfig = {
        method: 'get',
        url: '/teacher/api/learning_status/student/classroom_average_by_month/',
        headers: {
            'Content-Type': 'application/json',
        },
        params: {
          student_id: student_id,
          subject_id: SUBJECT_ID_MAP[subject],
          year: year,
          month: month,
          ...(work && { work_id: work }),
        },
      };
      const avgByMonth = await apiRequest(config);
      return avgByMonth.data.classroom_average_by_month
    },
    async fetchLearningStatusStudentFetchDetailByWeek({student_id, subject, work}) {
      const config: AxiosRequestConfig = {
        method: 'get',
        url: '/teacher/api/learning_status/student/detail_by_week/',
        headers: {
            'Content-Type': 'application/json',
        },
        params: {
          student_id: student_id,
          subject_id: SUBJECT_ID_MAP[subject],
          ...(work && { work_id: work }),
        },
      };
      const detailByWeek = await apiRequest(config);
      return detailByWeek.data.detail_by_week
    },
    async fetchLearningStatusStudentFetchAvgByWeek({student_id, subject, work}) {
      const config: AxiosRequestConfig = {
        method: 'get',
        url: '/teacher/api/learning_status/student/classroom_average_by_week/',
        headers: {
            'Content-Type': 'application/json',
        },
        params: {
          student_id: student_id,
          subject_id: SUBJECT_ID_MAP[subject],
          ...(work && { work_id: work }),
        },
      };
      const avgByWeek = await apiRequest(config);
      return avgByWeek.data.classroom_average_by_week
    },
    async fetchLearningStatusStudentFetchTotalStudyMinutes({student_id, subject, work}) {
      const config: AxiosRequestConfig = {
        method: 'get',
        url: '/teacher/api/learning_status/student/total_study_minutes/',
        headers: {
            'Content-Type': 'application/json',
        },
        params: {
          student_id: student_id,
          subject_id: SUBJECT_ID_MAP[subject],
          ...(work && { work_id: work }),
        },
      };
      const total_study_minutes = await apiRequest(config);
      return total_study_minutes.data
    },
  }
})

export {useLearningStatusStudentStore, Student}